<template>
  <div class="box">
    <div class="head">
      <Header></Header>
    </div>
    <!-- 市场合作 -->
    <div class="div">
      <div class="across"></div>
      <div class="tabs">
        <div class="crumbs">
          <span>
            <!-- <router-link :to="{ path: '/' }"> -->
            <img src="../../assets/images/header/white.png" alt="logo" />
            首页
            <!-- </router-link> -->
          </span>
          <!-- &gt;
          <span @click="activeName = 'one'" style="cursor: pointer"
            >联系我们</span
          > -->
          &gt;
          <span>{{ text }}</span>
        </div>
        <el-tabs v-model="activeName">
          <el-tab-pane label="市场合作" name="one">
            <div class="relation">
              <div class="left" id="map"></div>
              <div class="right">
                <!-- <div class="socialBenefits">
                  <div class="title">福利待遇：</div>
                  福利待遇福利待遇福利待遇福利待遇福利待遇福利待遇福利待遇
                  <br />
                  福利待遇福利待遇福利待遇福利待遇福利待遇福利待遇福利待遇
                  <br />
                  福利待遇福利待遇福利待遇福利待遇福利待遇福利待遇福利待遇
                  <br />
                  福利待遇福利待遇福利待遇福利待遇福利待遇福利待遇福利待遇
                  <br />
                </div>
                <div class="recruitment">
                  <div>校园招聘：fangwei@zhongzeyuhua.com</div>
                  <div>社会招聘：fangwei@zhongzeyuhua.com</div>
                </div> -->

                <div>
                  <h3>合作对象</h3>
                  <div><span class="pore"></span>产品代理商</div>
                  <div><span class="pore"></span>软件零售，批发商</div>
                  <div>
                    <span class="pore"></span>其他愿与我们展开合作的单位与企业
                  </div>
                </div>
                <div class="target">
                  <h3>合作目标</h3>
                  <div>
                    公司将吸纳、培养一批有行业和区域实力的产品代理商，作为长期稳定发展的合作伙伴，承担销售、服务等业务，逐渐形成一个不同经营模式、不同层次的立体合作代理渠道，努力为最终客户提供更可信、更有价值的产品和服务。
                  </div>
                </div>
                <div>
                  <h3>联系方式</h3>
                  <div>邮箱：fangwei@zhongzeyuhua.com</div>
                  <div>联系方式：18510508157</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="foot">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "@/views/header/Header.vue";
import Footer from "@/views/footer/Footer.vue";
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  components: { Header, Footer },
  data() {
    return {
      activeName: "one",
      text: "市场合作",
    };
  },

  created() {
    this.$store.state.menu = 6;
  },

  mounted() {
    this.mapInit();
  },

  methods: {
    mapInit() {
      AMapLoader.load({
        key: "6d36347fd4b5e9ff39a3eee772f1a77c", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], //插件列表
      })
        .then((AMap) => {
          let map = new AMap.Map("map", {
            center: [116.328257, 39.783333],
            zoom: 13,
          });

          // 创建一个 Marker 实例：
          var marker = new AMap.Marker({
            position: new AMap.LngLat(114.164237, 30.50674), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: "东合中心E座",
          });
          var marker1 = new AMap.Marker({
            position: new AMap.LngLat(116.328257, 39.783333),
            title: "西红门兴创国际中心四期",
          });
          let mk = [marker, marker1];
          // 将创建的点标记添加到已有的地图实例：
          map.add(mk);
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  watch: {
    activeName(news) {
      switch (news) {
        case "one":
          this.text = "市场合作";
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  .head {
    position: fixed;
    width: 100%;
    height: 100px;
    background-color: #fff;
    z-index: 5;
    color: #333;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  }
  .div {
    width: 100%;
    padding-top: 100px;
    .across {
      width: 100%;
      height: 50px;
      background-color: #0064a1;
    }
    .tabs {
      position: relative;
      padding: 0 50px;
      max-width: 1200px;
      min-width: 900px;
      margin: auto;
      margin-top: -45px;
      .relation {
        display: flex;
        justify-content: space-between;
        margin: 70px 0;
        .left {
          width: 60%;
          height: 400px;
          background-color: #7eaeca;
          /deep/.amap-logo {
            display: none !important;
          }
          /deep/.amap-copyright {
            display: none !important;
          }
        }
        .right {
          width: 40%;
          padding-left: 100px;
          h3 {
            font-weight: 500;
            font-size: 20px;
            // margin: 10px 0;
            margin: 20px 0 10px 0;
            color: #333;
          }
          > div {
            color: #666;
            font-size: 16px;
            line-height: 1.5;
            .pore {
              display: inline-block;
              width: 6px;
              height: 6px;
              background-color: #666;
              margin-bottom: 2px;
              margin-right: 5px;
            }
          }
          .target {
            div {
              text-indent: 2em;
            }
          }
        }
        // .right {
        //   display: flex;
        //   flex-direction: column;
        //   justify-content: space-between;
        //   align-items: center;
        //   padding-left: 50px;
        //   width: 50%;
        //   .socialBenefits {
        //     color: #666;
        //     font-size: 14px;
        //     line-height: 1.5;
        //     .title {
        //       color: #333;
        //       font-size: 20px;
        //       line-height: 50px;
        //     }
        //   }
        //   .recruitment {
        //     font-size: 20px;
        //     color: #333;
        //     line-height: 35px;
        //     font-weight: 400;
        //   }
        // }
      }
    }
  }
  .crumbs {
    position: absolute;
    right: 50px;
    line-height: 40px;
    z-index: 2;
    color: #fff;
    font-size: 16px;
  }
  .router-link-active {
    text-decoration: none;
    color: #fff;
  }
  // tabs标题的字号
  /deep/ .el-tabs__item {
    font-size: 16px;
  }
}
</style>
